<script lang="ts">
  import { onDestroy } from 'svelte'
  import { debounce } from 'es-toolkit'
  import useObjectQueries from '../../../hooks/useObjectQueries'
  import { ThreeItemKeys } from '../../../../../constants/three'
  import i18n from '../../../../../i18n'
  import useFileQueries from '../../../hooks/useFileQueries'
  import usePrintersQueries from '../../../hooks/usePrintersQueries'
  import Select from '../../../../../components/select/Select.svelte'
  import SectionContainer from '../SectionContainer.svelte'
  import ControlGroup from '../../../../../components/control-group/ControlGroup.svelte'
  import InputLabel from '../InputLabel.svelte'
  import ControlGroupContent from '../../../../../components/control-group/ControlGroupContent.svelte'

  type Props = { objectId: string }
  const { objectId }: Props = $props()

  let assignedPrinterId = $state<string>()
  let isSyncingFromGroup = false

  const { useObject } = useObjectQueries()

  const { assignToPrinterMutation } = useFileQueries()
  let groupQuery = $derived(useObject(objectId))
  let group = $derived(groupQuery.data)

  const { usePrinters } = usePrintersQueries()
  const printersData = usePrinters()

  const onStateUpdate = debounce(
    (targetObjectId: string, printerId: string) => {
      assignToPrinterMutation.mutate({ fileId: targetObjectId, printerId })
    },
    500,
  )

  onDestroy(() => onStateUpdate.cancel())

  $effect(() => {
    isSyncingFromGroup = true
    assignedPrinterId = group?.userData[ThreeItemKeys.ASSIGNED_PRINTER_ID]
  })

  $effect(() => {
    const printerId = assignedPrinterId

    if (isSyncingFromGroup) {
      isSyncingFromGroup = false
      return
    }

    if (printerId !== undefined) {
      onStateUpdate(objectId, printerId)
    }
  })
</script>

<SectionContainer title={$i18n.t('project.rightBar.printerAssignment.title')}>
  <ControlGroup>
    <InputLabel>
      {$i18n.t('project.rightBar.printerAssignment.description')}
    </InputLabel>
    <ControlGroupContent>
      <Select
        name="printer"
        options={[
          {
            label: $i18n.t('project.rightBar.printerAssignment.noPrinter'),
            value: null,
          },
          ...(printersData.data ?? []).map(item => ({
            label: item.name,
            value: item.userData[ThreeItemKeys.PRINTER_ID],
          })),
        ]}
        placeholder={$i18n.t('project.rightBar.printerAssignment.noPrinter')}
        bind:value={assignedPrinterId}
      />
    </ControlGroupContent>
  </ControlGroup>
</SectionContainer>

<style lang="scss">
  p {
    color: var(--right-bar-muted-foreground);
    font-size: 0.75rem;
    line-height: 100%;
  }
</style>
